'use client';
import * as e from 'react';

function makeGetKey(e) {
    return `${e}/get`;
}
function makeHasKey(e) {
    return `${e}/has`;
}
function browserHistoryStateHas(e, t) {
    return (null == e ? void 0 : e[makeHasKey(t)]) === !0;
}
function browserHistoryStateGet(e, t) {
    return null == e ? void 0 : e[makeGetKey(t)];
}
function browserHistoryStateGetOrDefault(e, t, r) {
    return browserHistoryStateHas(e, t) ? browserHistoryStateGet(e, t) : r;
}
function useBrowserHistoryState(t, r, a) {
    let [o, s] = e.useState(()=>'undefined' != typeof window ? browserHistoryStateGetOrDefault(window.history.state, t, r) : r), i = (null == a ? void 0 : a.replace) === !0;
    return e.useEffect(()=>{
        let e = browserHistoryStateGetOrDefault(window.history.state, t, r);
        !o && e && i ? window.history.replaceState({
            [makeGetKey(t)]: !1,
            [makeHasKey(t)]: !0
        }, '') : JSON.stringify(o) !== JSON.stringify(e) && (window.history.pushState({
            [makeGetKey(t)]: o,
            [makeHasKey(t)]: !0
        }, ''), i && window.history.replaceState({
            [makeGetKey(t)]: !1,
            [makeHasKey(t)]: !0
        }, ''));
    }, [
        o,
        t,
        r,
        i
    ]), e.useEffect(()=>{
        let popStateHandler = (e)=>{
            let a = browserHistoryStateGetOrDefault(e.state, t, r);
            JSON.stringify(a) !== JSON.stringify(o) && s(a);
        };
        return window.addEventListener('popstate', popStateHandler), ()=>window.removeEventListener('popstate', popStateHandler);
    }, [
        o,
        t,
        r
    ]), [
        o,
        s
    ];
}

export { useBrowserHistoryState };
